import { ActionTree } from 'vuex';
import { RootState } from '../store';
import { DocumentsState } from '../stores/documents.store';
import { mutationIsLoadingTags, mutationSetTags } from '../mutations/documents.mutations';
import { ITag } from '@/types/Tag';
import { translate } from '@/helpers/translation.helper';
import service from '@/services/entity.service';

export const actionSetIsLoadingTags = 'setIsLoadingTags';
export const actionLoadEntityTagSuccess = 'loadEntityTagSuccess';
export const actionLoadEntityTagFailed = 'loadEntityTagFailed';
export const actionLoadEntityTags = 'loadEntityTags';

export const actions: ActionTree<DocumentsState, RootState> = {
  async [actionLoadEntityTags]({ dispatch }) {
    dispatch(actionSetIsLoadingTags, true);
    try {
      const tags: ITag[] = await service.fetchEntityTags();
      dispatch(actionLoadEntityTagSuccess, tags);
    } catch (e) {
      dispatch(actionLoadEntityTagFailed);
    }
  },
  async [actionLoadEntityTagSuccess]({ commit, dispatch }, tags: ITag[]) {
    commit(mutationSetTags, tags);
    dispatch(actionSetIsLoadingTags, false);
  },
  async [actionLoadEntityTagFailed]({ dispatch }) {
    dispatch(
      'alert/showDangerAlert',
      translate('could-not-load-entity-tags', {
        root: true,
      })
    );
    dispatch(actionSetIsLoadingTags, false);
  },
  async [actionSetIsLoadingTags]({ commit }, payload: boolean) {
    commit(mutationIsLoadingTags, payload);
  },
};
